import {ProvisionContractRunStatus} from '../enum/provision-contract-run-status.enum';

/**
 * How ONE ProvisionContractRunStatus (the per-contract outcome inside a run) is presented.
 *
 * Same shape as {@link ProvisionRunStatusPresentation} and the bm reference
 * `bm/model/billing-run-status-presentation.ts` (PAT §J.2). Used by KPI K-02 ("Verarbeitete
 * Verträge", 01 §6) on the dashboard start page and — reused, not re-declared — by the
 * "Verträge" tab of the run detail (04 §5.3).
 */
export interface ProvisionContractRunStatusPresentation {
    label: string;
    icon: string;
    text: string;
    background: string;
}

export const PROVISION_CONTRACT_RUN_STATUS_PRESENTATION: { [status: number]: ProvisionContractRunStatusPresentation } = {
    [ProvisionContractRunStatus.CALCULATED]: {label: 'Berechnet', icon: 'fa-solid fa-calculator', text: 'text-blue-800', background: 'bg-blue-100'},
    [ProvisionContractRunStatus.UNCHANGED]: {label: 'Unverändert', icon: 'fa-solid fa-equals', text: 'text-700', background: 'bg-100'},
    [ProvisionContractRunStatus.NOT_ELIGIBLE]: {label: 'Nicht provisionsfähig', icon: 'fa-solid fa-circle-minus', text: 'text-700', background: 'bg-100'},
    [ProvisionContractRunStatus.CANCELLATION_PROCESSED]: {label: 'Storno verarbeitet', icon: 'fa-solid fa-rotate-left', text: 'text-orange-800', background: 'bg-orange-100'},
    [ProvisionContractRunStatus.ERROR]: {label: 'Fehler', icon: 'fa-solid fa-triangle-exclamation', text: 'text-red-800', background: 'bg-red-100'},
    [ProvisionContractRunStatus.ABORTED]: {label: 'Abgebrochen', icon: 'fa-solid fa-ban', text: 'text-700', background: 'bg-100'}
};

/**
 * Display order of the outcome chips. Explicit, not derived from the ordinal, for the same reason
 * the run status bar is explicit (04 §5.2): the ordinal is a persistence contract, not a reading
 * order. The two outcomes that need attention (Fehler, Storno) are deliberately NOT last.
 */
export const PROVISION_CONTRACT_RUN_STATUS_DISPLAY_ORDER: ProvisionContractRunStatus[] = [
    ProvisionContractRunStatus.CALCULATED,
    ProvisionContractRunStatus.CANCELLATION_PROCESSED,
    ProvisionContractRunStatus.ERROR,
    ProvisionContractRunStatus.UNCHANGED,
    ProvisionContractRunStatus.NOT_ELIGIBLE,
    ProvisionContractRunStatus.ABORTED
];

export const PROVISION_CONTRACT_RUN_STATUS_UNKNOWN: ProvisionContractRunStatusPresentation = {
    label: 'Unbekannt', icon: 'fa-solid fa-question', text: 'text-700', background: 'bg-100'
};

export function provisionContractRunStatusPresentation(status: number | undefined | null): ProvisionContractRunStatusPresentation {
    if (status == null) {
        return PROVISION_CONTRACT_RUN_STATUS_UNKNOWN;
    }
    return PROVISION_CONTRACT_RUN_STATUS_PRESENTATION[status] || PROVISION_CONTRACT_RUN_STATUS_UNKNOWN;
}
